const debounce = (func, delay) => {
  if (!func) return;
  if (func.debounceTimer) {
    clearTimeout(func.debounceTimer);
  }
  func.debounceTimer = setTimeout(func, typeof delay === "number" ? delay : 500);
};

export default debounce;
